module.exports = __webpack_public_path__ + "img/YellowBook_icon.5336855a.png";